import { Token } from '@lumino/coreutils';
/**
 * The token for the settings service.
 */
export const ITranslation = new Token('@jupyterlite/translation:ITranslation');
//# sourceMappingURL=tokens.js.map